import { render, staticRenderFns } from "./JumpsellerPromotionListComponent.vue?vue&type=template&id=789ef19f&scoped=true&"
import script from "./JumpsellerPromotionListComponent.vue?vue&type=script&lang=js&"
export * from "./JumpsellerPromotionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ef19f",
  null
  
)

export default component.exports